import { useCallback, useEffect, useRef, useState } from "react";
import ResizeObserver from "resize-observer-polyfill";

const MAX_MOBILE_WIDTH = 768;
const MAX_TABLET_WIDTH = 1000;
const MAX_MOBILE_HEIGHT = 1000;
type Orientation = "landscape" | "portrait";
function useWindowWidth() {
  const isMounted = useRef<boolean>(true);
  const isSsr = typeof window === "undefined";
  const [appWidth, setAppWidth] = useState(isSsr ? 0 : window.innerWidth);
  const [appHeight, setAppHeight] = useState(isSsr ? 0 : window.innerHeight);
  const [isMobile, setIsMobile] = useState(true);
  const [isTablet, setIsTablet] = useState(true);
  const [orientation, setOrientation] = useState<Orientation>("landscape");
  const handleResize = useCallback(() => {
    if (isMounted.current) {
      setAppWidth(window.innerWidth);
      setAppHeight(window.innerHeight);
      setOrientation(
        window.innerWidth > window.innerHeight ? "landscape" : "portrait"
      );
      setIsMobile(
        window.innerWidth <= MAX_MOBILE_WIDTH ||
          (window.innerWidth < MAX_MOBILE_HEIGHT &&
            window.innerHeight < MAX_MOBILE_WIDTH)
      );
      setIsTablet(
        (window.innerWidth >= MAX_MOBILE_WIDTH &&
          window.innerWidth <= MAX_TABLET_WIDTH) ||
          (window.innerWidth < MAX_MOBILE_HEIGHT &&
            window.innerHeight < MAX_MOBILE_WIDTH)
      );
    }
  }, [setAppWidth]);

  useEffect(() => {
    const observer = new ResizeObserver(handleResize);

    const element = window.document.querySelector("html");
    if (!element) return;
    observer.observe(element);

    return () => {
      isMounted.current = false;
      if (!element) return;
      observer.unobserve(element);
    };
  }, [handleResize]);

  return { appWidth, appHeight, orientation, isMobile, isTablet };
}

export default useWindowWidth;
